import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  defaultOrgsDataReceiver,
  orgTypesFilterSelection,
  orgsFilter,
  orgsFilterSelection,
} from 'app/dataProviders/filter-items'
import { OrgType } from 'app/dataTypes/org'
import { useCallback, useEffect } from 'react'
import { subscibeTo, useDataBoxSelector } from 'app/common/data-box-store'
import { OrgsFilterInfo } from './OrgsFilterInfo'

type Props = {
  id: string
  pending: boolean
}

export const OrgsFilter = ({ id, pending }: Props) => {
  const data = useDataBoxSelector(orgsFilter, () => orgsFilter.data)

  const orgTypesFilterHandler = useCallback((data: OrgType[]) => {
    if (data.length === 1) {
      orgsFilter.addDataReceiver(defaultOrgsDataReceiver)
      orgsFilter.dataReceive()
      return
    }
    orgsFilter.resetToDefault()
  }, [])

  useEffect(() => {
    const unsubsribeOrgType = subscibeTo<OrgType[]>(
      orgTypesFilterSelection.id,
      orgTypesFilterHandler,
    )
    return () => {
      unsubsribeOrgType()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (data.length === 1) {
      const orgId = 'id' in data[0] ? [data[0].id] : ['empty']
      orgsFilterSelection.updateData(() => orgId)
    }
  }, [data])

  return (
    <>
      <PlainItemsSelectorBox
        id={id}
        label="Заведение"
        header="Выбор заведения"
        dataBoxData={orgsFilter}
        dataBoxSelection={orgsFilterSelection}
        pleaseSelectText="Нет данных"
        disabled={pending}
        emptyTitle="Не указано"
      />
      <OrgsFilterInfo />
    </>
  )
}
